import { render } from "./TieredMenuSub.vue?vue&type=template&id=73a372f2"
import script from "./TieredMenuSub.vue?vue&type=script&lang=js"
export * from "./TieredMenuSub.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Github\\dev-mynet\\Products\\Hub\\web\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__